/** */
export const CREATE_MESSAGE = 'create mobile push message';
export const DELETE_MESSAGE = 'delete mobile push message';
export const READ_MESSAGE = 'read mobile push messages';
export const UPDATE_MESSAGE = 'update mobile push message';

/** */
export const ADD_ONE_MESSAGE_TO_STORE = 'add one mobile push message to store';
export const ADD_MANY_MESSAGES_TO_STORE = 'add many mobile push messages to store';
export const ADD_SEARCH_RESULTS_TO_STORE = 'add mobile push message search results to store';
export const LOAD_MESSAGE_TO_STORE = 'load mobile push messages to store from API call';
export const REMOVE_MANY_MESSAGES_FROM_STORE = 'remove many mobile push messages from the store.';
export const REMOVE_ONE_MESSAGE_FROM_STORE = 'remove a mobile push message from the store.';

/** */
export const createMobilePushMessage = (payload) => ({
  type: CREATE_MESSAGE,
  payload
});

export const deleteMobilePushMessage = (payload) => ({
  type: DELETE_MESSAGE,
  payload
});

export const deleteManyMobilePushMessages = (payload) => ({
  type: REMOVE_MANY_MESSAGES_FROM_STORE,
  payload
});

export const readMobilePushMessage = (payload) => ({
  type: READ_MESSAGE,
  payload
});

export const updateMobilePushMessageInStore = (payload) => ({
  type: UPDATE_MESSAGE,
  payload
});

/** */

export const addManyMobilePushMessagesToStore = (payload) => ({
  type: ADD_MANY_MESSAGES_TO_STORE,
  payload
});

export const addOneMobilePushMessageToStore = (payload) => ({
  type: ADD_ONE_MESSAGE_TO_STORE,
  payload
});

export const addMobilePushMessageSearchResultsToStore = (payload) => ({
  type: ADD_SEARCH_RESULTS_TO_STORE,
  payload
});

export const loadMobilePushMessagesToStore = (payload) => ({
  type: LOAD_MESSAGE_TO_STORE,
  payload
});

export const removeManyMobilePushMessagesFromStore = (payload) => ({
  type: REMOVE_MANY_MESSAGES_FROM_STORE,
  payload
});

export const removeOneMobilePushMessageFromStore = (payload) => ({
  type: REMOVE_ONE_MESSAGE_FROM_STORE,
  payload
});
